import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "micro_book",
  "use": "micro_book-usage",
  "viewBox": "0 0 10 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 10 10\" id=\"micro_book\"><path fill-rule=\"evenodd\" d=\"M3.493 9.383A1 1 0 0 0 2.5 8.5H2a1 1 0 0 0-1 1 .5.5 0 0 1-1 0v-8A1.5 1.5 0 0 1 1.5 0H3a1.5 1.5 0 0 1 1.5 1.5v8a.5.5 0 0 1-1 0l-.007-.117Zm5.5 0A1 1 0 0 0 8 8.5h-.5a1 1 0 0 0-1 1 .5.5 0 0 1-1 0v-8A1.5 1.5 0 0 1 7 0h1.5A1.5 1.5 0 0 1 10 1.5v8a.5.5 0 0 1-1 0l-.007-.117Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol